export default {
    uah: '₴',
    validate: {
        Login: {
            email: {
                required: 'Введите электронный адрес',
                email: 'Некорректный электронный адрес'
            },
            password: {
                required: 'Введите пароль',
                minLength: 'Минимальная длина пароля - 6 символов'
            }
        },
        Register: {
            email: {
                required: 'Введите электронный адрес',
                email: 'Некорректный электронный адрес'
            },
            password: {
                required: 'Введите пароль',
                minLength: 'Минимальная длина пароля - 6 символов'
            },
            confirmPassword: {
                required: 'Подтвердите пароль',
                equal: 'Пароли не совпадают'
            },
            firstName: {
                required: 'Введите имя'
            },
            lastName: {
                required: 'Введите фамилию'
            }
        },
        Businesses: {
            businessId: {
                numeric: 'Некорректный номер Бизнеса'
            },
            refillSum: {
                required: 'Введите сумму',
                numeric: 'Неверное значение'
            },
            fee: {
                numeric: 'Некорректный процент'
            },
            limits: {
                clientLimit: {
                    max: 'Превышен лимит'
                }
            }
        },
        UnallocatedClients: {
            fee: {
                numeric: 'Некорректный процент'
            }
        },
        Leaders: {
            leaderId: {
                numeric: 'Некорректный номер Лидера'
            },
            refillSum: {
                required: 'Введите сумму',
                numeric: 'Неверное значение'
            },
            fee: {
                numeric: 'Некорректный процент'
            },
            limits: {
                accountLimit: {
                    max: 'Максимальное количество аккаунтов - 10.000'
                },
                clientBase: {
                    max: 'Максимальное количество клиентов - 1.000.000'
                }
            }
        },
        AdminEditor: {
            phoneNumber: {
                required: 'Введите номер телефона',
                length: 'Телефонный номер некорректный'
            },
            taxId: {
                required: 'Введите ИНН',
                length: 'Длина ИНН - 10 символов'
            },
            cardNumber: {
                required: 'Введите номер карты',
                length: 'Номер карты некорректный'
            },
            firstName: {
                required: 'Введите имя'
            },
            lastName: {
                required: 'Введите фамилию'
            },
            email: {
                required: 'Введите электронный адрес',
                email: 'Некорректный электронный адрес'
            },
            passportNumber: {
                required: 'Введите номер паспорта'
            }
        },
        RoleEditor: {
            name: {
                required: 'Введите название роли'
            }
        },
        Cards: {
            clientId: {
                numeric: 'Некорректный номер клиента'
            },
            paymentId: {
                numeric: 'Некорректный номер платежа'
            },
            phoneNumber: {
                length: 'Некорректный номер телефона'
            }
        },
        News: {
            header: {
                required: 'Введите заголовок'
            },
            publicationDate: {
                required: 'Выберите дату публикации'
            },
            publicationTime: {
                required: 'Выберите время публикации'
            },
            text: {
                required: 'Введите текст публикации',
                maxLength: 'Текст должен быть менее 400 символов'
            },
            imageSize: {
                minValue: 'Слишком большой размер файла'
            }
        },
        BalanceHistory: {
            clientId: {
                numeric: 'Некорректный номер клиента'
            },
            paymentId: {
                numeric: 'Некорректный номер платежа'
            },
            taxiOrderId: {
                numeric: 'Некорректный номер заказа такси'
            },
            phoneNumber: {
                required: 'Введите номер телефона',
                length: 'Некорректный номер телефона'
            },
            amount: {
                required: 'Введите сумму',
                numeric: 'Некорректная сумма'
            },
            comment: {
                length: 'Длинна превышает 255 символов'
            }
        },
        Referral: {
            clientId: {
                numeric: 'Некорректный номер клиента'
            }
        },
        Payments: {
            taxiOrderId: {
                numeric: 'Некорректный номер заказа такси'
            },
            clientId: {
                numeric: 'Некорректный номер клиента'
            },
            orderId: {
                numeric: 'Некорректный номер заказа'
            },
            phoneNumber: {
                numeric: 'Телефонный номер некорректный'
            }
        },
        Notification: {
            title: {
                required: 'Введите заголовок'
            },
            body: {
                maxLength: 'Слишком длинный текст'
            },
            phoneFilters: {
                maxLength: 'Слишком длинный текст'
            }
        },
        PromotionalLeader: {
            numberOfFunds: {
                required: 'Введите количество средств',
                decimal: 'Некорректное количество средств',
                isEnoughMoney: 'Недостаточно денег'
            },
            amount: {
                required: 'Введите количество бизнесов'
            },
            accountId: {
                required: 'Выберите лидера'
            },
            date: {
                required: 'Введите дату'
            }
        },
        PromotionalBusiness: {
            date: {
                required: 'Введите дату'
            },
            accountId: {
                required: 'Выберите бизнеса'
            },
            amount: {
                required: 'Введите кол-во клиентов'
            }
        },
        PurchasePromotional: {
            money: {
                required: 'Введите сумму',
                decimal: 'Сумма некорректная',
                isEnoughMoney: 'Недостаточно денег'
            }
        },
        CreateAccount: {
            activeLeader: {
                required: 'Введите лидера'
            },
            roleId: {
                required: 'Введите роль'
            }
        },
        Payouts: {
            withdraw: {
                availablePrice: 'На Вашем счету недостаточно средств',
                decimal: 'Некорректная сумма',
                multipleOf: 'Сумма должна быть кратна 100'
            }
        },
        Settings: {
            password: {
                required: 'Введите пароль',
                minLength: 'Минимальная длина пароля - 6 символов'
            },
            newPassword: {
                required: 'Введите новый пароль',
                minLength: 'Минимальная длина пароля - 6 символов'
            },
            confirmNewPassword: {
                required: 'Подтвердите новый пароль',
                equal: 'Пароли не совпадают'
            },
            phoneNumber: {
                required: 'Введите номер телефона',
                length: 'Телефонный номер некорректный'
            },
            passportNumber: {
                required: 'Введите номер паспорта'
            },
            taxId: {
                required: 'Введите ИНН',
                length: 'Длина ИНН - 10 символов'
            },
            cardNumber: {
                required: 'Введите номер карты',
                length: 'Номер карты некорректный'
            },
            firstName: {
                required: 'Введите имя'
            },
            lastName: {
                required: 'Введите фамилию'
            }
        },
        ExtendedReports: {
            Editor: {
                name: {
                    required: 'Введите название отчета'
                },
                sqlQuery: {
                    required: 'Сформируйте SQL-запрос'
                }
            },
            Categories: {
                name: {
                    required: 'Введите название категории'
                }
            }
        },
        other: {
            numeric: 'Неверное значение'
        },
        Groups: {
            name: {
                required: 'Введите название'
            },
            phones: {
                required: 'Введите телефоны'
            },
            brand: {
                required: 'Выберите бренд'
            },
            subGroups: {
                numeric: 'Некоректное значение',
                max: 'Превышен максимум',
                min: 'Ниже минимума'
            },
            count: {
                required: 'Введите количество поездок',
                numeric: 'Некоректное значение',
                max: 'Превышен максимум',
                min: 'Некоректное значение'
            },
            fromDate: {
                required: 'Выберите дату',
                max: 'Некоректное значение'
            },
            toDate: {
                required: 'Выберите дату',
                max: 'Превышен максимум'
            }
        },
        CashbackEditor: {
            name: {
                required: 'Введите название'
            },
            groupId: {
                required: 'Выберите группу'
            },
            fromDate: {
                required: 'Выберите дату'
            },
            toDate: {
                required: 'Выберите дату'
            }
        }
    },
    locales: {
        en: 'English',
        ru: 'Русский',
        uk: 'Українська'
    },
    menu: {
        addClientArticle: 'Создать новость',
        articleList: 'Список новостей',
        login: 'Вход',
        register: 'Регистрация',
        clientArticleEditor: 'Редактирование новости',
        dashboard: 'Информационная панель',
        edit: 'Редактировать',
        customers: 'Клиенты',
        customerEditor: 'Редактирование клиента',
        payments: 'Платежи',
        paymentLog: 'Журнал платежа',
        admin: 'Администратор',
        admins: 'Администраторы',
        adminEditor: 'Редактирование администратора',
        rolesManaging: 'Управление ролями',
        roles: 'Список ролей',
        permissions: 'Список разрешений',
        createRole: 'Создать новую роль',
        user: 'Пользователь',
        referral: 'Рефералы',
        customersBase: 'Клиентская база',
        business: 'Бизнесы',
        yourBusinesses: 'Ваши бизнесмены',
        card: 'Карты',
        newsEditor: 'Создать новость',
        news: 'Новости',
        balanceHistory: 'История баланса',
        notification: 'Push-уведомления',
        createAccount: 'Создать аккаунт',
        leaders: 'Лидеры',
        accountBalanceHistory: 'Финансы',
        clientRefillHistory: 'История пополнений баланса клиентов',
        leaderReferralCodes: 'Коды для приглашения клиентов',
        businessReferralCodes: 'Коды для приглашения бизнесов',
        payouts: 'Выплаты',
        payoutsLogs: 'История заявки',
        reports: 'Отчеты',
        leaderReport: 'Отчеты',
        businessReport: 'Отчеты',
        systemNotifications: 'Уведомления',
        systemLogs: 'Активность',
        systemLogsSettings: 'Настройки активности',
        settings: 'Настройки',
        leaderGroup: 'По лидерам',
        businessGroup: 'По бизнесам',
        dayGroup: 'Вывод средств',
        reportLeaderGroup: 'Отчет по лидерам',
        reportBusinessGroup: 'Отчет по бизнесам',
        reportDayGroup: 'Отчет по выводу средств',
        extendedReports: 'Расширенные  отчеты',
        extendedReportsList: 'Список расширеных отчетов',
        extendedReportsCategories: 'Список категорий отчетов',
        promotionalAccount: 'Рекламный счет',
        bonusSystems: 'Бонусные системы',
        groups: 'Группы клиентов',
        cashbackSystems: 'Кэшбэк и бонусы',
        cashbackEditor: 'Редактирование бонусной системы',
        cashbackCreator: 'Создание бонусной системы',
        unallocatedClients: 'Нераспределенные клиенты',
        moderation: 'Модерация',
        clientNews: 'Клиентские новости',
        undefined: ''
    },
    pages: {
        ClientNewsEditor: {
            articleData: 'Данные новости'
        },
        AddClientArticle: {
            sendTo: {
                all: 'Все',
                allTaxi: 'Все (такси)',
                allDelivery: 'Все (доставка)',
                selected: 'Выбрать номера'
            }
        },
        ClientNews: {
            table: {
                id: 'Номер новости',
                createdAt: 'Создана',
                sendTo: 'Кому отправлена',
                status: 'Статус',
                header: 'Заголовок',
                text: 'Текст новости',
                actions: 'Действия'
            },
            status: {
                shown: 'Опубликована',
                hide: 'Спрятана'
            },
            sendTo: {
                all: 'Всем',
                allTaxi: 'Клиентам такси',
                allDelivery: 'Клиентам доставки',
                selected: 'Выбранным номерам'
            },
            delete: 'Удалить',
            cancel: 'Отменить',
            deleteTitle: 'Удалить новость?',
            cannotBeUndone: 'Это действие необратимо'
        },
        Login: {
            title: 'Вход в систему',
            submit: 'Войти',
            form: {
                email: 'Электронный адрес',
                password: 'Пароль'
            },
            forgotPassword: 'Забыли пароль?',
            rememberMe: 'Запомнить меня',
            socialTitle: 'Или войдите с помощью',
            emailText: 'Мы отправили инструкцию по восстановлению пароля на <strong>:email</strong> (проверьте папки «Входящие» и «Спам»).',
            forgotPasswordTitle: 'Инструкции отправлены',
            emailSubject: 'Забыли пароль? Восстановите его!',
            forgotText: 'Здравствуйте! Вы отправили запрос на восстановление пароля от Вашего электронного адреса. Для того, чтобы задать новый пароль, перейдите по ссылке'
        },
        Register: {
            title: 'Регистрация в системе',
            submit: 'Зарегистрироваться',
            form: {
                email: 'Электронный адрес',
                firstName: 'Имя',
                lastName: 'Фамилия',
                password: 'Пароль',
                confirmPassword: 'Подтвердите пароль',
                role: 'Роль',
                includeTelephony: 'Учитывать оффлайн заказы'
            }
        },
        ReferralCodes: {
            editText: 'Нажмите Enter чтобы сохранить',
            table: {
                name: 'Название',
                code: 'Код',
                actions: ''
            }
        },
        Dashboard: {
            overviewBalance: 'Ваш баланс',
            overviewPercent: 'Процент',
            overviewClients: 'Ваши клиенты',
            overviewBusinesses: 'Ваши бизнесмены',
            referralTitle: 'График привлечения клиентов',
            balanceTitle: 'График Вашего заработка',
            overviewFee: 'Онлайн процент',
            overviewTelephonyFee: 'Оффлайн процент',
            clientBase: 'База клиентов',
            accountLimit: 'Лимит аккаунтов',
            clientLimit: 'Лимит клиентов',
            autoPromoBalance: 'Автоматический рекламный баланс',
            promoBalance: 'Ручной рекламный баланс',
            noDataReferrals: 'Пока что Вы никого не привлекли',
            noDataBalance: 'Пока что Вы ничего не заработали',
            noOrders: 'Ваши клиенты не совершили ни одной поездки',
            editText: 'Нажмите Enter чтобы сохранить',
            ordersAnalytics: 'Аналитика заказов',
            ordersTitle: 'История Ваших заказов',
            ordersIncomeTitle: 'Доходы с заказов',
            table: {
                balance: 'Баланс',
                clients: 'Клиенты',
                online: 'Онлайн заказы',
                offline: 'Телефония',
                deliveryOrders: 'Заказы доставки'
            },
            dateMenu: {
                month: 'Месяц',
                week: 'Неделя',
                day: 'День'
            }
        },
        UnallocatedClients: {
            cards: {
                workedServerCount: 'Количество серверов',
                all: 'Количество клиентов',
                unallocated: 'Нераспределенные клиенты',
                allocated: 'Распределенные клиенты'
            },
            table: {
                id: 'Номер',
                name: 'Название',
                enabled: 'Aктивный',
                apiUrl: 'API url',
                apiKey: 'API ключ',
                balance: 'Баланс',
                fee: 'Процент',
                createdAt: 'Создано',
                city: 'Город',
                actions: ''
            },
            enabled: {
                true: 'Да',
                false: 'Нет'
            },
            editFeeText: 'Нажмите Enter что бы сохранить',
            reset: {
                title: 'Подтвердите действие',
                text: 'Вы уверены, что хотите обнулить баланс данного сервера?',
                actions: {
                    agree: 'Подтвердить',
                    disagree: 'Отменить'
                }
            }
        },
        Payments: {
            autocomplete: {
                type: 'Выберите тип платежа',
                status: 'Выберите статус платежа',
                cardBinding: 'Добавление карты (1₴)',
                orderPayment: 'Платеж за поездку',
                deliveryPayment: 'Платёж за доставку',
                rechargeBalance: 'Пополнение баланса',
                new: 'Новый',
                success: 'Успешно',
                error: 'Ошибка',
                sandbox: 'Sandbox'
            },
            table: {
                clientId: 'Номер клиента',
                phoneNumber: 'Номер телефона',
                taxiOrderId: 'Номер заказа',
                orderId: 'Номер транзакции',
                amount: 'Сумма',
                status: 'Статус',
                type: 'Тип',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                actions: ''
            },
            clientId: 'Номер клиента',
            phoneNumber: 'Номер телефона',
            taxiOrderId: 'Номер заказа',
            orderId: 'Номер транзакции',
            link: 'К журналу платежа'
        },
        PaymentLogs: {
            table: {
                request: 'Запрос',
                response: 'Ответ',
                type: 'Тип',
                createdAt: 'Создано',
                updatedAt: 'Обновлено'
            }
        },
        Referrals: {
            tableTitle: 'Ваши клиенты',
            autocomplete: {
                noData: 'Данные отсутствуют'
            },
            table: {
                clientId: 'Номер клиента',
                createdAt: 'Дата регистрации',
                paymentType: 'Тип оплаты по умолчанию',
                balance: 'Баланс',
                card: 'Карта',
                cash: 'Наличные',
                referralCode: 'Реферальный код',
                referralCodeName: 'Название реферальной кода',
                businessEmail: 'Пригласил клиента',
                leaderEmail: 'Электронный адрес лидера'
            },
            clientId: 'Номер клиента',
            businessShareText: 'Вызвать такси за 3 секунды? Со Sprut возможно все! Скачивай мобильное приложение по ссылке: ',
            leaderShareText: 'Поздравляем! Начни свой бизнес в такси уже сейчас! Регистрируйся по ссылке: '
        },
        Admins: {
            email: 'Email',
            role: 'Название роли',
            phone: 'Номер телефона',
            table: {
                id: 'Номер администратора',
                email: 'Электронный адрес',
                createdAt: 'Создано',
                firstName: 'Имя',
                lastName: 'Фамилия',
                appVersion: 'Версия приложения',
                cardNumber: 'Номер карты',
                taxId: 'Идентификационный код',
                phoneNumber: 'Номер телефона',
                role: 'Роль пользователя',
                actions: 'Действия'
            }
        },
        AdminEditor: {
            adminInfo: 'Информация об администраторе',
            firstName: 'Имя',
            customerInfo: 'Информация о клиенте',
            lastName: 'Фамилия',
            email: 'Электронный адрес',
            phoneNumber: 'Номер телефона',
            cardNumber: 'Номер карты',
            taxId: 'Идентификационный код',
            passportNumber: 'Номер паспорта',
            roleInfo: 'Информация о роли',
            role: 'Роль'
        },
        Roles: {
            name: 'Название роли',
            table: {
                name: 'Название роли',
                adminsCount: 'Количество пользователей',
                state: 'Состояние',
                actions: 'Действия',
                active: 'Активная',
                disabled: 'Не активная'
            },
            permissionsSettings: {
                name: 'Название разрешения',
                activation: 'Активация'
            },
            permissionsList: {
                'watch-payments': 'Просмотр истории платежей',
                'send-push-notifications': 'Отправка Push-уведомлений',
                'watch-balance-history': 'Просмотр истории баланса',
                'refill-client-balance': 'Пополнение баланса клиентов',
                'watch-cards': 'Просмотр карт пользователей',
                'watch-leaders': 'Просмотр списка лидеров',
                'watch-business': 'Просмотр списка бизнесов',
                'create-account': 'Создание аккаунтов',
                'watch-referrals': 'Просмотр списка рефералов',
                'create-news': 'Работа с публикациями',
                'watch-account-balance-history': 'Просмотр истории баланса аккаунта',
                'edit-withdraws': 'Просмотр выплат и работа с ними',
                'watch-reports': 'Просмотр отчетов',
                'edit-admins': 'Работа со списком администраторов',
                'edit-roles': 'Работа со списком ролей',
                'change-admin-permissions': 'Доступ к списку всех разрешений',
                'watch-extended-reports': 'Просмотр расширенных отчетов',
                'edit-extended-reports': ' Редактирование расширенных отчетов',
                'watch-client-refill-history': 'История пополнений баланса клиентов',
                'watch-system-logs': 'Доступ к активности',
                'watch-client-groups': 'Просмотр групп клиентов',
                'watch-cashback-system': 'Просмотр систем кэшбэка',
                'watch-unallocated-clients': 'Просмотр нераспределенных клиентов',
                'lock-account': 'Блокирование аккаунтов',
                'client-news': 'Доступ к клиентским новостям'
            }
        },
        RoleEditor: {
            name: 'Название роли',
            edit: 'Редактирование роли',
            create: 'Новая роль',
            available: 'Доступные',
            chosen: 'Выбранные',
            established: 'Установленные',
            permissionsList: 'Список разрешений для роли',
            reportCategoriesList: 'Категории отчетов',
            active: 'Активная',
            disabled: 'Не активная',
            emptyList: 'Список разрешений пустой'
        },
        Businesses: {
            tableTitleConfirmed: 'Список привлеченных бизнесменов - {0}',
            tableTitleUnconfirmed: 'Ожидают подтверждения электронной почты - {0}',
            adminTitle: 'Список бизнесов',
            adminUnconfirmedTitle: 'Ожидают подтверждения элетронной почты',
            businessId: 'Введите номер бизнесмена',
            query: 'Введите запрос',
            table: {
                email: 'Электронный адрес',
                businessId: 'Номер бизнеса',
                firstName: 'Имя',
                lastName: 'Фамилия',
                phoneNumber: 'Номер телефона',
                createdAt: 'Создано',
                referrerEmail: 'Электронный адрес лидера',
                balance: 'Баланс',
                fee: 'Онлайн процент',
                telephonyFee: 'Оффлайн процент',
                leaderFee: 'Онлайн % от лидера',
                leaderTelephonyFee: 'Оффлайн % от лидера',
                refillBalance: 'Пополнить баланс',
                refillPromoBalance: 'Пополнить рекламный счет',
                clientLimit: 'Лимит клиентов',
                limitedTo: 'Ограничен до',
                processedAfterRestrictions: 'Обработан после ограничений',
                unlimitedRights: 'Неограниченные права',
                purchased: 'Аккаунт куплен',
                clients: 'Рефералы',
                autoPromoBalance: 'Автоматический рекламный баланс',
                actions: 'Действия',
                lock: 'Заблокировать аккаунт',
                unlock: 'Разблокировать аккаунт',
                settings: 'Настройки ограничений',
                amountToPay: 'Стоимость аккаунта',
                amountPaid: 'Выплаченная сумма'
            },
            limits: {
                title: 'Изменение ограничений',
                available: 'Всего доступно: {0}',
                used: 'Использовано'
            },
            refillSum: 'Введите сумму пополнения',
            lockDialog: {
                title: 'Заблокировать бизнеса',
                message: 'Аккаунт этого бизнеса будет заблокирован и он не сможет пользоваться системой'
            }
        },
        Cards: {
            table: {
                id: 'ID',
                clientId: 'Номер клиента',
                phoneNumber: 'Номер телефона клиента',
                paymentId: 'Номер платежа',
                cardMask: 'Маска карты',
                cardToken: 'Токен карты',
                default: 'По умолчанию',
                errorCount: 'Счетчик ошибок',
                createdAt: 'Создано',
                updatedAt: 'Обновлено'
            },
            clientId: 'Номер клиента',
            paymentId: 'Номер платежа',
            phoneNumber: 'Номер телефона клиента',
            true: 'Да',
            false: 'Нет'
        },
        News: {
            selects: {
                all: 'Всем',
                leader: 'Лидерам',
                business: 'Бизнесам'
            },
            count: 'Количество новостей',
            header: 'Информация для партнеров',
            showTo: 'Показать',
            showText: 'Публикация',
            latePublication: 'Отложенная публикация',
            publicationDate: 'Дата публикации',
            publicationTime: 'Время публикации',
            text: 'Текст публикации',
            image: 'Выберите изображение',
            share: 'Выберите реферальный код, чтобы поделиться',
            noCode: 'У вас нет ни одного реферального кода. Создайте его перед тем как поделиться',
            edit: 'Редактирование публикации',
            create: 'Новая публикация',
            shareImageBlock: {
                code: {
                    size: 'Размер кода(px)',
                    position: 'Позиция',
                    positions: {
                        'top-left': 'Сверху слева',
                        'top-right': 'Сверху справа',
                        'bottom-left': 'Снизу слева',
                        'bottom-right': 'Снизу справа'
                    }
                },
                addQRCode: 'Добавить QR код'
            }
        },
        balanceHistories: {
            table: {
                id: 'ID',
                clientId: 'Номер клиента',
                phoneNumber: 'Номер телефона клиента',
                taxiOrderId: 'Номер заказа',
                paymentId: 'Номер платежа',
                change: 'Изменения',
                balance: 'Баланс',
                cashbackSystemId: 'Номер бонусной системы',
                paymentType: 'Тип платежа',
                orderType: 'Тип заказа',
                comment: 'Комментарий',
                createdAt: 'Создано',
                updatedAt: 'Обновлено',
                refilledBy: 'Пополнено(кем)',
                system: 'Система',
                success: 'Успешно'
            },
            refillDialog: {
                title: 'Пополнить баланс клиенту',
                phoneNumber: 'Номер телефона',
                sum: 'Сумма пополнения',
                comment: 'Комментарий'
            },
            clientId: 'Номер клиента',
            taxiOrderId: 'Номер заказа',
            paymentId: 'Номер платежа',
            paymentType: 'Тип платежа',
            paymentTypes: {
                refill: 'Пополнение',
                trip: 'Поездка',
                delivery: 'Доставка',
                taxi: 'Такси',
                cashback: 'Кэшбэк'
            },
            phoneNumber: 'Номер телефона клиента'
        },
        Notification: {
            count: 'Количество уведомлений',
            clients: 'Готовые к отправке',
            filters: {
                selectAll: 'Выбрать всех клиентов',
                phones: 'Телефоны',
                success: 'Успешно',
                duplicate: 'Дубликаты',
                notFound: 'Не найдено',
                withoutToken: 'Без токена',
                validationError: 'Ошибка валидации'
            },
            message: {
                title: 'Заголовок *',
                body: 'Текст',
                image: 'Ссылка на изображение'
            },
            result: {
                title: 'Результат',
                androidSuccess: 'Android успешно',
                androidFailure: 'Android не успешно',
                iosSuccess: 'iOS успешно',
                iosFailure: 'iOS не успешно'
            },
            error: {
                invalidToken: 'Не верный токен устройства',
                emptyToken: 'Токен устройства не отправлено',
                requiredData: 'Поле с телом запроса не отправлено',
                couldNotParsed: 'Невозможно прочитать тело запроса',
                InvalidRegistration: 'Неверная регистрация',
                NotRegistered: 'Не зарегистрирован',
                InvalidPackageName: 'Неверное имя пакета',
                MismatchSenderId: 'Несоответствие идентификатора отправителя',
                InvalidParameters: 'Неверные параметры',
                MessageTooBig: 'Слишком большое сообщение',
                InvalidDataKey: 'Неверный ключ данных',
                Unavailable: 'Недоступен',
                InternalServerError: 'Внутренняя Ошибка Сервера',
                DeviceMessageRateExceeded: 'Превышена скорость сообщения устройства',
                BadCollapseId: 'Неверный идентификатор',
                BadDeviceToken: 'Неверный токен устройства',
                BadExpirationDate: 'Неверный срок годности',
                BadMessageId: 'Неверный идентификатор сообщения',
                BadPriority: 'Плохой приоритет',
                BadTopic: 'Плохая тема',
                DeviceTokenNotForTopic: 'Токен устройства не принадлежит теме',
                DuplicateHeaders: 'Дублирующиеся заголовки',
                IdleTimeout: 'Время простоя',
                MissingDeviceToken: 'Отсутствует токен устройства',
                MissingTopic: 'Недостающая тема',
                PayloadEmpty: 'Полезная нагрузка пуста',
                TopicDisallowed: 'Тема запрещена',
                BadCertificate: 'Плохой сертификат',
                BadCertificateEnvironment: 'Плохая среда сертификатов',
                ExpiredProviderToken: 'Токен просрочен',
                Forbidden: 'Запрещено',
                InvalidProviderToken: 'Неверный токен провайдера',
                MissingProviderToken: 'Отсутствует токен провайдера',
                BadPath: 'Плохой путь',
                MethodNotAllowed: 'Метод не разрешен',
                Unregistered: 'незарегистрированный',
                PayloadTooLarge: 'Слишком большая полезная нагрузка',
                TooManyProviderTokenUpdates: 'Слишком много обновлений токена провайдера',
                TooManyRequests: 'Слишком много запросов',
                ServiceUnavailable: 'Сервис недоступен',
                Shutdown: 'Неисправность'
            }
        },
        RefRegister: {
            title: 'Добро пожаловать в Sprut',
            invalidCode: 'Неверный реферальный код',
            confirmation: 'Введите код, отправленный на',
            registered: 'Поздравляем! Вы стали клиентом SPRUT',
            buttons: {
                appStore: 'Скачать в <br> <b>App Store</b>',
                googlePlay: 'Скачать в <br> <b>Google Play</b>'
            }
        },
        Leaders: {
            or: 'или',
            id: 'Введите номер лидера',
            query: 'Введите запрос',
            table: {
                id: 'Номер лидера',
                email: 'Электронный адрес',
                createdAt: 'Создано',
                firstName: 'Имя',
                lastName: 'Фамилия',
                phoneNumber: 'Номер телефона',
                balance: 'Баланс',
                fee: 'Онлайн процент',
                telephonyFee: 'Оффлайн процент',
                brandCode: 'Код бренда',
                refillBalance: 'Пополнить баланс',
                refillPromoBalance: 'Пополнить рекламный счет',
                clientBase: 'База клиентов',
                accountLimit: 'Лимит аккаунтов',
                limitedTo: 'Ограничен до',
                processedAfterRestrictions: 'Обработан после ограничений',
                unlimitedRights: 'Неограниченные права',
                purchased: 'Аккаунт куплен',
                clients: 'Рефералы',
                businesses: 'Бизнесы',
                distributedClients: 'Распределенные клиенты',
                promoBalance: 'РРБ',
                autoPromoBalance: 'АРБ',
                actions: 'Действия',
                enableTelephony: 'Включить заказы телефонии',
                disableTelephony: 'Выключить заказы телефонии',
                lock: 'Заблокировать аккаунт',
                unlock: 'Разблокировать аккаунт',
                settings: 'Настройки ограничений',
                amountToPay: 'Стоимость аккаунта',
                amountPaid: 'Выплаченная сумма'
            },
            limits: {
                title: 'Изменение ограничений'
            },
            refillSum: 'Введите сумму пополнения',
            lockDialog: {
                title: 'Заблокировать лидера',
                message: 'Аккаунт этого лидера будет заблокирован и он не сможет пользоваться системой'
            }
        },
        CreateAccounts: {
            selects: {
                admin: 'Админ',
                leader: 'Лидер',
                business: 'Бизнес'
            }
        },
        Settings: {
            form: {
                password: 'Пароль',
                newPassword: 'Новый пароль',
                confirmNewPassword: 'Подтвердите новый пароль'
            },
            tabs: {
                details: 'Личные данные',
                settings: 'Настройки входа'
            },
            labels: {
                firstName: 'Имя',
                lastName: 'Фамилия',
                email: 'Электронный адрес',
                phoneNumber: 'Номер телефона',
                cardNumber: 'Номер карты',
                taxId: 'Идентификационный код',
                passportNumber: 'Номер паспорта',
                role: 'Информация о роли'
            },
            personalInfo: 'Персональная информация',
            additionalInfo: 'Дополнительная информация',
            connectAccount: 'Подключить аккаунт',
            changePass: 'Смена пароля',
            fbAccount: 'Facebook аккаунт',
            googleAccount: 'Google аккаунт',
            confirmation: {
                title: 'Сохранение персональных данных',
                description: 'Если Вы подтвердите сохранение, Ваша учетная запись будет временно заблокирована, а данные будут переданы администрации на рассмотрение.'
            },
            agreedWith: 'Согласен(-на) с',
            termsOfUsage: 'условиями использования'
        },
        BusinessRegister: {
            title: 'Подтвердите свой электронный адрес!',
            description: 'Ваш акаунт был успешно зарегистрирован. Для завершения процесса, пожалуйста, проверьте Ваш электронный адрес',
            emailSubject: 'Вы успешно зарегистрировались! Осталось только подтвердить почту!',
            registerText: 'Мы рады видеть Вас в нашей команде SPRUT. Остался последний шаг! Перейдите по ссылке, чтобы подтвердить регистрацию Вашего аккаунта'
        },
        AccountBalanceHistory: {
            currentAccountBalance: 'Ваш нынешний баланс (₴)',
            table: {
                partner: 'Партнер',
                clientId: 'Номер клиента',
                phoneNumber: 'Номер телефона',
                taxiOrderId: 'Номер заказа такси',
                change: 'Поступление',
                balance: 'Баланс',
                cashbackSystemId: 'Номер кэшбэк системы',
                bonusBalance: 'Показать рекламный счет',
                type: 'Тип поступления',
                email: 'Электронный адрес',
                statuses: {
                    trip: 'Поездка',
                    refill: 'Пополнение',
                    delivery: 'Доставка'
                },
                createdAt: 'Создано'
            }
        },
        clientRefillHistory: {
            table: {
                date: 'Дата',
                change: 'Сумма пополнения',
                balance: 'Баланс',
                phoneNumber: 'Номер телефона',
                refilledBy: 'Пополнено(кем)',
                comment: 'Комментарий'
            }
        },
        Payouts: {
            table: {
                sum: 'Сумма',
                balance: 'Баланс',
                accountId: 'Номер пользователя',
                type: 'Тип',
                email: 'Электронный адрес',
                firstName: 'Имя',
                lastName: 'Фамилия',
                phoneNumber: 'Номер телефона',
                status: 'Статус',
                cardNumber: 'Номер карты',
                comment: 'Комментарий',
                updatedAt: 'Обновлено',
                createdAt: 'Дата заявки'
            },
            statuses: {
                new: 'Новый',
                processing: 'В обработке',
                success: 'Завершенный',
                cancelled: 'Отмененный'
            },
            filters: {
                status: 'Выберите статус',
                query: 'Введите запрос'
            },
            payoutDescription: 'Вы можете оставить заявку на вывод заработанных средств. Среднее время ожидания - 3 банковских дня. Заявка может быть отклонена в случае обнаружения мошеннических действий на аккаунте.',
            payoutDialogTitle: 'Вы уверены, что хотите вывести ',
            onBalance: 'На Вашем балансе',
            withdraw: 'Вывод средств',
            withdrawAll: 'Снять все',
            sum: 'Сума в гривнах',
            hrn: 'грн'
        },
        Reports: {
            sum: 'Сумма',
            table: {
                date: 'Дата',
                invitedClients: 'Приглашенные клиенты',
                totalTrips: 'Количество поездок',
                earnedMoney: 'Заработано денег'
            },
            leader: {
                table: {
                    business: 'Бизнес',
                    invitedClients: 'Приглашенные клиенты',
                    totalTrips: 'Количество поездок',
                    earnedMoney: 'Заработано денег лидером',
                    earnedReferralsMoney: 'Заработано денег бизнесом'
                }
            },
            admin: {
                table: {
                    business: 'Бизнес',
                    leader: 'Лидер',
                    invitedBusinesses: 'Приглашенные бизнесы',
                    invitedClients: 'Приглашенные клиенты',
                    totalTrips: 'Количество поездок',
                    earnedLeaderMoney: 'Заработано денег лидером',
                    earnedBusinessMoney: 'Заработано денег бизнесом',
                    earnedBusinessesMoney: 'Заработано денег бизнесами',
                    date: 'Дата',
                    totalBalance: 'Денег на балансах',
                    requested: 'Запрошено на вывод',
                    success: 'Выведено'
                }
            }
        },
        ExtendedReports: {
            List: {
                table: {
                    '#': '#',
                    name: 'Название',
                    category: 'Категория',
                    sqlQuery: 'SQL-запрос',
                    created: 'Создано',
                    updated: 'Обновлено',
                    actions: 'Действия',
                    forLeader: 'Для лидера'
                },
                filters: {
                    sqlQuery: 'SQL-запрос'
                }
            },
            Editor: {
                create: 'Новый отчет',
                edit: 'Редактирование отчета',
                remove: 'Вы действительно хотите удалить данный отчет ?',
                name: 'Название',
                category: 'Категория',
                sqlQuery: 'SQL-запрос',
                meta: 'SQL-метаданные',
                useDate: 'Фильтр по датам',
                useTime: 'Фильтр по времени',
                useQuery: 'Текстовый запрос',
                forLeader: 'Для лидера'
            },
            Reports: {
                category: ' Категория',
                report: 'Отчет',
                filtration: 'Фильтрация',
                another: 'Другое',
                filters: {
                    startDate: 'Дата начала',
                    endDate: 'Дата окончания',
                    startTime: 'Время начала',
                    endTime: 'Время окончания',
                    query: 'Текстовый запрос'
                }
            },
            Categories: {
                name: 'Название',
                list: 'Список категорий отчетов',
                action: 'Действия',
                remove: ' Вы действительно хотите удалить эту категорию ?',
                edit: 'Редактирование категории',
                create: 'Новая категория'
            }
        },
        PayoutLog: {
            table: {
                id: 'ID',
                status: 'Статус',
                updatedAt: 'Обновлено',
                createdAt: 'Создано'
            }
        },
        SystemNotifications: {
            title: {
                newBusiness: 'Новый бизнес',
                emailConfirmed: 'Подтверждение email',
                newClient: 'Новый клиент',
                refilledPromoBalance: 'Пополнение рекламного счета',
                withdrawRequest: 'Вывод средств',
                resetFee: 'Обнуление процента'
            },
            autocomplete: {
                type: 'Выберите тип',
                status: 'Выберите статус',
                read: 'Прочитано',
                unread: 'Непрочитано',
                newBusiness: 'Новый бизнес',
                refilledpromoBalance: 'Пополнение рекламного счета',
                emailConfirmed: 'Бизнес подтвердил email',
                newClient: 'Новый клиент',
                withdrawRequest: 'Вывод средств'
            },
            refilledPromoBalance: 'Пополнение рекламного счета на {currency} грн',
            newBusiness: 'Бизнесмен {content} стал Вашим партнером!',
            emailConfirmed: 'Бизнесмен {content} подтвердил свою электронную почту!',
            newClient: 'Поздравляем! Клиент {content} зарегистрировался и стал Вашим партнером!',
            withdrawRequest: '{content} запросил вывод средств!',
            noData: 'У Вас нет уведомлений',
            resetFee: '18.06. 2021г. заканчивается бонусное начисление дивидендов. Для дальнейшего сотрудничества Вам необходимо связаться с администрацией.'
        },
        ConfirmAccount: {
            confirmedTitle: 'Аккаунт успешно подтвержден',
            unconfirmedTitle: 'Ссылка уже недействительна',
            subject: 'Подтверждение аккаунта',
            text: 'Чтобы подтвердить аккаунт, перейдите по ссылке'
        },
        SystemLogs: {
            actionType: 'Тип действия',
            email: 'Пользователь',
            models: {
                ClientGroup: {
                    name: 'Название',
                    type: 'Тип',
                    countOfOrders: 'Кол-во заказов',
                    values: 'Кол-во заказов',
                    subGroups: 'Кол-во подгрупп',
                    fromDate: 'Дата начала',
                    toDate: 'Дата завершения',
                    includeUnallocated: 'Включать нераспределенных',
                    onlyUnallocated: 'Только нераспределенные',
                    accountId: 'Количество клиентов',
                    brandId: 'ID бренда',
                    isDelivery: 'Группа доставки',
                    brand: 'Бренд'
                },
                CashbackSystem: {
                    name: 'Название',
                    clientGroup: 'Группа клиентов',
                    fromDate: 'Дата начала',
                    toDate: 'Дата завершения',
                    includeTelephony: 'Включать оффлайн заказы',
                    bonusReward: 'Вознаграждение',
                    textOnCreate: 'Текст при создании',
                    textOnReward: 'Текст вознаграждения',
                    Step: {
                        name: 'Название системы кэшбэка',
                        percent: 'Процент кэшбэка',
                        text: 'Текст при достижении',
                        order: 'Количество заказов'
                    }
                },
                RASystem: {
                    name: 'Название бонусной системы',
                    clientGroup: 'Группа клиентов',
                    fromDate: 'Дата начала',
                    toDate: 'Дата завершения',
                    bonusReward: 'Вознаграждение',
                    textOnCreate: 'Текст при создании',
                    textOnReward: 'Текст вознаграждения',
                    Step: {
                        name: 'Название бонусной системы',
                        bonusReward: 'Вознаграждение',
                        text: 'Текст при достижении',
                        bonusCondition: 'Условие достижения'
                    }
                },
                LTSystem: {
                    name: 'Название бонусной системы',
                    clientGroup: 'Группа клиентов',
                    fromDate: 'Дата начала',
                    toDate: 'Дата завершения',
                    bonusReward: 'Вознаграждение',
                    textOnCreate: 'Текст при создании',
                    textOnReward: 'Текст вознаграждения',
                    Step: {
                        name: 'Название бонусной системы',
                        bonusReward: 'Вознаграждение',
                        text: 'Текст при достижении',
                        bonusCondition: 'Условие достижения'
                    }
                }
            },
            table: {
                date: 'Дата',
                user: 'Пользователь',
                actionType: 'Тип действия',
                action: 'Действие'
            },
            types: {
                'login': 'Вход в систему',
                'push-notification-send': 'Push-уведомления',
                'refill-account-balance': 'Пополнение баланса аккаунта',
                'create-code': 'Создание реферального кода',
                'create-account': 'Создание аккаунта',
                'create-news': 'Создание публикации',
                'remove-news': 'Удаление публикации',
                'change-action-type-status': 'Изменение в настройках активности',
                'remove-code': 'Удаление реферального кода',
                'change-personal-data': 'Изменение персональных данных',
                'connect-google-account': 'Подключение google аккаунта',
                'connect-facebook-account': 'Подключение facebook аккаунта',
                'change-servers-fee': 'Изменение серверного процента',
                'set-to-zero-server-balance': 'Обнуление серверного баланса',
                'change-permission': 'Изменения в списке всех разрешений',
                'change-admin-data': 'Редактирование данных администратора',
                'change-role': 'Редактирование роли',
                'create-role': 'Создание роли',
                'remove-role': 'Удаление роли',
                'change-fee': ' Изменение процента',

                'create-client-group': 'Создание группы клиентов',
                'edit-client-group': 'Редактирование группы клиентов',
                'remove-client-group': 'Удаление группы клиентов',

                'create-cashback-system': 'Создание системы кэшбека',
                'change-cashback-system-activity': 'Активация системы кэшбека',
                'edit-cashback-system': 'Изменения системы кэшбека',
                'complete-cashback-system': 'Завершение системы кэшбека',

                'create-cashback-step': 'Создание условия начисления кэшбека',
                'edit-cashback-step': 'Редактирование условия начисления кэшбека',
                'remove-cashback-step': 'Удаление условия начисления кэшбека',

                'create-ra-system': 'Создание бонусной системы по достижению суммы',
                'edit-ra-system': 'Редактирование бонусной системы по достижению суммы',
                'change-ra-system-activity': 'Активация бонусной системы по достижению суммы',
                'complete-ra-system': 'Завершение бонусной системы по достижению суммы',

                'create-lt-system': 'Создание бонусной системы по количеству заказов',
                'edit-lt-system': 'Редактирование бонусной системы по количеству заказов',
                'change-lt-system-activity': 'Активация бонусной системы по количеству заказов',
                'complete-lt-system': 'Завершение бонусной системы по количеству заказов',

                'create-ra-step': 'Создание условия начисления бонуса по достижению суммы',
                'edit-ra-step': 'Редактирование условия начисления бонуса по достижению суммы',
                'remove-ra-step': 'Удаление условия начисления бонуса по достижению суммы',

                'create-lt-step': 'Создание условия начисления бонуса по количеству заказов',
                'edit-lt-step': 'Редактирование условия начисления бонуса по количеству заказов',
                'remove-lt-step': 'Удаление условия начисления бонуса по количеству заказов',

                'funds-purchase': 'Покупка рекламных средств',
                'funds-charge': 'Пополнение рекламного счета',
                'lock-account': 'Блокирование аккаунта',
                'change-account-status': 'Изменение статуса аккаунта',
                'change-account-price': 'Изменение цены аккаунта'
            },
            messages: {
                'login': 'Сессия была создана с параметром "Запомнить меня" со значением {0}',
                'refill-account-balance': 'Баланс пользователя {0} был пополнен на {1} грн.',
                'create-code': 'Пользователь {0} создал реферальный код {1} с названием "{2}"',
                'remove-code': 'Пользователь {0} удалил реферальный код {1} с названием "{2}"',
                'create-account': 'Создан новый аккаунт {0} с ролью "{1}"',
                'lock-account': 'Аккаунт {0} был {1}',
                'change-action-type-status': 'Логирование действия "{0}" было {1}',
                'change-permission': ' Разрешение типа "{0}" было {1}',
                'create-news': 'Пользователь {0} создал новую публикацию с заголовком "{1}"',
                'remove-news': 'Пользователь {0} удалил публикацию с заголовком "{1}"',
                'connect-google-account': 'Пользователь {0} подключил google-аккаунт',
                'connect-facebook-account': 'Пользователь {0} подключил facebook-аккаунт',
                'push-notification-send': 'Пользователь {0} отправил push-уведомления {1} клиентам: {2} успешно, {3} не успешно',
                'change-servers-fee': 'Изменен процент для сервера {0} - c {1} на {2}',
                'set-to-zero-server-balance': 'Обнулено баланс сервера - {0}',
                'create-role': 'Администратор {0} создал роль "{1}" с разрешениями: {2}.',
                'remove-role': 'Роль "{0}" была удалена.',
                'change-fee': 'Администратор {0} изменил процент для аккаунта {1} с {2}% на {3}%',
                'create-client-group': 'Создана группа клиентов "{0}" с параметрами:\n{1}',
                'remove-client-group': 'Группа клиентов "{0}" была удалена',
                'create-cashback-system': 'Создана система кэшбека с параметрами:\n{0}',
                'change-cashback-system-activity': 'Система кэшбека "{0}" -> {1}',
                'complete-cashback-system': 'Система кэшбека "{0}" была завершена',

                'create-ra-system': 'Создана бонусная система по достижению суммы с параметрами:\n{0}',
                'change-ra-system-activity': 'Бонусная система по достижению суммы "{0}" -> {1}',
                'complete-ra-system': 'Бонусная система по достижению суммы "{0}" была завершена',

                'create-lt-system': 'Создана бонусная система по количеству заказов с параметрами:\n{0}',
                'change-lt-system-activity': 'Бонусная система по количеству заказов "{0}" -> {1}',
                'complete-lt-system': 'Бонусная система по количеству заказов "{0}" была завершена',
                'change-personal-data': {
                    user: 'Пользователь {0}',
                    add: 'заполнил поле "{0}" значением "{1}" в своем  аккаунте',
                    change: 'изменил значение поля "{0}" с "{1}" на "{2}"',
                    readTerms: 'ознакомился с условиями использования'
                },
                'change-admin-data': {
                    user: 'Пользователь {0} редактировал аккаунт {1}',
                    add: ' заполнил поле "{0}" значение "{1}"',
                    change: 'изменил значение поля "{0}" с "{1}" на "{2}"'
                },
                'change-role': {
                    user: 'Пользователь {0} изменил роль {1}',
                    name: 'название с {0} на {1}',
                    permissions: 'список разрешений с [{0}] на [{1}]',
                    categories: 'список категорий отчетов с [{0}] на [{1}]',
                    activity: ' роль была',
                    enabled: 'активирована',
                    disabled: 'деактивирована'
                },
                'edit-client-group': {
                    result: 'Изменена группа клиентов "{0}"',
                    change: 'поле "{0}" с {1} на {2}',
                    linkClients: 'включены клиенты пользователя номер {0}',
                    unlinkClients: 'отключены клиенты пользователя номер {0}'
                },
                'edit-cashback-system': {
                    result: 'Изменена система кешбека "{0}"',
                    change: 'поле "{0}" с {1} на {2}'
                },
                'edit-ra-system': {
                    result: 'Изменена бонусная система по достижению суммы "{0}"',
                    change: 'поле "{0}" с {1} на {2}'
                },
                'edit-lt-system': {
                    result: 'Изменена бонусная система по количеству заказов "{0}"',
                    change: 'поле "{0}" с {1} на {2}'
                },
                'funds-purchase': 'Куплено рекламных средств: {0} по коэффициенту {1}',
                'funds-charge': {
                    admin: {
                        all: {
                            leader: 'Рекламный счёт всех лидеров(кол-во - {0}) был пополнен на {1} ₴',
                            business: 'Рекламный счёт всех бизнесов(кол-во - {0}) был пополнен на {1} ₴',
                            client: 'Рекламный счёт всех клиентов(кол-во - {0}) был пополнен на {1} ₴'
                        },
                        some: {
                            leader: 'Рекламный счёт лидера (id: {0}) был пополнен на {1} ₴',
                            business: 'Рекламный счёт бизнеса (id: {0}) был пополнен на {1} ₴'
                        },
                        amount: {
                            leader: 'Рекламный счёт лидеров, у которых более {0} бизнесов (кол-во - {1}), был пополнен на {2} ₴',
                            business: 'Рекламный счёт бизнесов, у которых  более {0} клиентов (кол-во - {1}), был пополнен на {2} ₴'
                        },
                        date: {
                            leader: 'Рекламный счёт лидеров, которые зарегистрировались {0} {1} (кол-во - {2}), был пополнен на {3} ₴',
                            business: 'Рекламный счёт бизнесов, которые зарегистрировались {0} {1} (кол-во - {2}), был пополнен на {3} ₴'
                        }
                    },
                    leader: {
                        all: {
                            business: 'Пополнил рекламный счёт всех своих бизнесов (кол-во - {0}) на {1} ₴',
                            client: 'Пополнил рекламный счёт всех своих клиентов (кол-во - {0}) на {1} ₴'
                        },
                        some: {
                            business: 'Пополнил рекламный счёт своего бизнеса (id: {0}) на {1} ₴'
                        },
                        amount: {
                            business: 'Пополнил рекламный счёт своих бизнесов, у которых более {0} клиентов (кол-во - {1}), на {2} ₴'
                        },
                        date: {
                            business: 'Пополнил рекламный счёт своих бизнесов, которые зарегистрировались {0} {1} (кол-во - {2}), на {3} ₴'
                        }
                    },
                    business: {
                        all: {
                            client: 'Пополнил рекламный счёт всех своих клиентов(кол-во - {0}) на {1} ₴'
                        }
                    },
                    before: 'до',
                    after: 'после'
                },
                'change-account-status': 'Статус аккаунта "{0}" был изменен с "{1}" на "{2}"',
                'change-account-price': 'Поле "{0}" аккаунта "{1}" было изменено с "{2}" на "{3}"',
                amountToPay: 'Стоимость аккаунта',
                amountPaid: 'Выплаченная сумма',
                promotionalFilters: {
                    all: 'всех {0}',
                    some: '{0}',
                    leader: 'лидеров',
                    business: 'бизнесов',
                    client: 'клиентов'
                },
                enabled: 'включено',
                disabled: 'выключено',
                locked: 'заблокирован',
                unlocked: 'разблокирован'
            },
            settings: {
                name: 'Тип логирования',
                activation: 'Активация'
            }
        },
        Reset: {
            title: 'Измените свой пароль',
            labels: {
                newPassword: 'Новый пароль',
                confirmPassword: 'Повторите пароль'
            }
        },
        PromotionalAccount: {
            before: 'До',
            after: 'После',
            promotionalAccountReplenishment: 'Пополнение ручного рекламного баланса',
            purchaseRate: 'Нынешний курс покупки',
            willBeBought: 'Будет куплено',
            wannaSpend: 'Хочу потратить',
            additionalSettings: 'Дополнительные настройки',
            numberOfUsers: 'Количество пользователей для начисления',
            numberOfFunds: 'Количество средств для начисления',
            numberOfBusinesses: 'Количество бизнесов',
            numberOfClients: 'Количество клиентов',
            promotionalAccountBalance: 'Ваш баланс рекламного счета составляет',
            advertisingBalance: 'Рекламный баланс',
            mainBalance: 'Основной баланс',
            leader: {
                all: 'Всем лидерам',
                some: 'Определенному лидеру',
                amount: 'Количество бизнесов больше N',
                date: 'Регистрация до/после'
            },
            business: {
                all: 'Всем бизнесам',
                some: 'Определенному бизнесу',
                amount: 'Количество клиентов больше N',
                date: 'Регистрация до/после'
            },
            client: {
                all: 'Всем клиентам',
                some: 'Клиентам бизнеса'
            }
        },
        Groups: {
            table: {
                id: 'Номер группы',
                establishment: 'Заведение',
                name: 'Название',
                selection: 'Выбор',
                type: 'Тип',
                values: 'Количество поездок',
                includeUnallocated: 'Включать нераспределенных',
                onlyUnallocated: 'Только нераспределенные',
                fromDate: 'С даты',
                toDate: 'По дату',
                accountId: 'Партнер',
                clients: 'Кол-во клиентов',
                createdAt: 'Создано',
                used: 'Используется',
                phones: 'Список телефонов',
                actions: 'Действия',
                brand: 'Бренд',
                isDelivery: 'Только доставка',
                scope: 'Цель',
                bonusSystem: 'Тип бонусов',
                autoAdd: 'Автодобавление',

                bonusSystems: {
                    sum: 'Сумма затрат',
                    count: 'Количество заказов',
                    cashbackPercent: '% кэшбэка'
                }
            },
            relocationOfClients: 'Перераспределение пользователей',
            someClientsAreAlreadyInGroup: 'Некоторые номера уже находятся в другой группе. Обратите внимание, что при создании новой они будут переведены в нее.',
            allEstablishments: 'Все заведения',
            all: 'Все',
            editor: {
                create: 'Создание группы',
                edit: 'Редактирование группы',
                startTyping: 'Начните вводить для поиска',
                subGroups: 'Количество подгрупп',
                clientsCount: 'Количество клиентов',
                willBeSentToAllClients: 'Включает в себя всех клиентов',
                autoAddNewClients: 'Автоматически добавлять новых клиентов',
                removeDialog: {
                    title: 'Удалить группу?',
                    desc: 'Данная группа будет полностью удалена из системы'
                }
            },
            selections: {
                custom: 'Ручной',
                condition: 'По условию',
                delivery: 'Доставка',
                taxi: 'Такси'
            },
            types: {
                equal: 'Равно',
                less: 'Меньше',
                more: 'Больше',
                range: 'Диапазон'
            },
            filters: {
                valuesFrom: 'Количество поездок от',
                valuesTo: 'Количество поездок до'
            },
            bonusSystems: {
                sum: 'По сумме затраченных денег',
                count: 'По количеству заказов',
                cashbackPercent: 'Процент кэшбэка (по умолчанию)'
            },
            validation: {
                success: 'Успешно',
                validationError: 'Ошибка валидации',
                alreadyInGroup: 'Уже в группе',
                notFound: 'Не найдено'
            },
            cashbackSystem: 'Система кэшбэка',
            countOfClients: 'Количество клиентов',
            withGroup: 'В группах',
            withoutGroup: 'Не в группах',
            unallocated: 'Нераспределенные',
            manualMode: 'Ручной режим',
            isDelivery: 'Доставка'
        },
        Cashback: {
            table: {
                id: 'Номер',
                name: 'Название',
                groupId: 'Группа',
                fromDate: 'С даты',
                toDate: 'По дату',
                enabled: 'Включена',
                wasStartedUp: 'Активная',
                progress: 'Прогресс',
                clients: 'Количество клиентов',
                totalOrderCount: 'Количество поездок',
                totalCommission: 'Комиссия',
                totalCashback: 'Кэшбэк',
                includeTelephony: 'Включать оффлайн заказы',
                createdAt: 'Создано',
                deletedAt: 'Завершено',
                actions: 'Действия',
                groupType: 'Тип группы',
                brand: 'Бренд',
                bonusSystem: 'Тип бонусов'
            },
            useAsTemplate: 'Использование системы кэшбэка как шаблона',
            filters: {
                countClientsFrom: 'Количество клиентов от',
                countClientsTo: 'Количество клиентов до',
                totalOrderFrom: 'Количество поездок от',
                totalOrderTo: 'Количество поездок до'
            }
        },
        CashbackEditor: {
            mainParams: 'Основные параметры',
            sequencesTable: 'Последовательная таблица начислений',
            table: {
                order: 'Номер поездки',
                percent: 'Процент',
                text: 'Текст пуш-уведомления',
                actions: 'Действия',
                amount: 'Сумма возврата',
                count: 'Количество заказов',
                sum: 'Потраченная сумма'
            }
        },
        Moderation: {
            statuses: {
                success: 'Проверено',
                check: 'Модерация',
                filling: 'Заполнение',
                cancelled: 'Ошибка'
            },
            table: {
                type: 'Тип',
                firstName: 'Имя',
                lastName: 'Фамилия',
                status: 'Статус',
                email: 'Электронный адрес',
                phoneNumber: 'Номер телефона',
                cardNumber: 'Номер карты',
                taxId: 'Идентификационный код',
                passportNumber: 'Номер паспорта',
                createdAt: 'Создано'
            }
        },
        404: {
            title: 'Упсс!',
            text: 'Похоже, ты на неизведанной территории. Мы еще не знаем об этой странице. К счастью, мы знаем дорогу назад.',
            return: 'Назад'
        }
    },
    types: {
        admin: 'Админ',
        leader: 'Лидер',
        business: 'Бизнес',
        client: 'Клиент'
    },
    messages: {
        error: {
            unknown: 'Неизвестная ошибка',
            invalidToken: 'Не верный токен устройства',
            isPhoneExist: 'Телефон уже зарегистрирован в системе',
            isAccountExist: 'Аккаунт уже зарегистрирован в системе',
            isCodeValid: 'Код подтверждения некорректный',
            emailAlreadyExist: 'Электронный адрес уже существует',
            accountAlreadyExist: 'Аккаунт уже существует',
            passwordDoesntMatch: 'Пароли не совпадают',
            accountNotFound: 'Аккаунт не найден',
            incorrectEmailOrPassword: 'Неверный электронный адрес или пароль',
            tokenInvalid: 'Токен недействителен',
            notAllAccountInformation: 'Для вывода средств заполните личную информацию в настройках Вашего аккаунта',
            invalidSum: 'Сумма некорректная',
            newsNotFound: 'Новость не существует',
            emailNotConfirmed: 'Электронный адрес не подтвержден',
            invalidAmount: 'Сумма некорректная',
            phoneNotFound: 'Номер телефона не существует',
            countUsers: 'Пользователей с такими параметрами не найдены',
            accessDenied: 'Доступ запрещен для вашей роли',
            roleNotFound: 'Роль не найдена',
            reportNotFound: 'Отчет не найден',
            reportGenerateError: 'Ошибка во время выполнения SQL-запроса',
            roleIdIsRequired: 'Невозможно создать администратора без роли',
            cannotDisableOwnRole: 'Вы не можете отключить роль, к которой относитесь',
            findAccountWithThisRole: 'Невозможно удалить роль, пока к ней относится хотя бы один аккаунт',
            reportFoundWithThisCategory: 'Эта категория содержит отчеты',
            incorrectEmail: 'Неверный электронный адрес',
            duplicateName: 'Это имя уже используется',
            accountLocked: 'Ваш аккаунт был заблокирован. Обратитесь к администратору',
            autologout: 'Вы слишком долго отсутствували. Пожалуйста, перезайдите',
            lessThanMin: 'Меньше минимального значения',
            moreThanLimit: 'Превышен установленный лимит',
            limits: {
                lessThanExistAccounts: 'Лимит аккаунтов не может быть меньше, чем количество приглашенных бизнесов.',
                lessThanExistClients: 'База клиентов не может быть меньше, чем количество приглашенных клиентов.',
                cantBeLimited: 'Аккаунт не может быть ограничен'
            },
            greaterThanLeaderFee: 'Вы не можете отдать больше, чем имеете',
            telephonyDisabled: 'Оффлайн заказы не включены',
            accountAmount: {
                lessThanMin: 'Меньше минимального значения',
                moreThanMax: 'Больше максимального значения',
                lessThanPaid: 'Меньше, чем уже оплачено',
                moreThanNeedPay: 'Больше, чем нужно оплатить'
            }
        },
        success: {
            login: 'Успешный вход',
            register: 'Аккаунт успешно создан. Пожалуйста, перейдите на почту и подтвердите регистрацию!',
            registerAdmin: 'Аккаунт успешно создан',
            deletedArticle: 'Новость была удалена',
            savedArticle: 'Новость сохранена',
            createdArticle: 'Новость создана',
            copy: 'Cкопировано в буфер обмена',
            successMessage: 'Сообщения успешно отправлены.',
            emailAlreadyExist: 'Электронный адрес уже существует',
            unknown: 'Неизвестная ошибка',
            accountRegister: 'Аккаунт успешно создан',
            accountUpdated: 'Аккаунт успешно обновлен',
            passwordChanged: 'Пароль успешно изменен',
            resend: 'На ваш телефон отправлено SMS с кодом подтверждения',
            feedCreated: 'Новость успешно опубликована',
            feedUpdated: 'Новость успешно обновлена',
            feedDeleted: 'Новость успешно удалена',
            linkShared: 'Вы успешно поделились ссылкой',
            refillBalance: 'Баланс успешно пополнен',
            refillPromoBalance: 'Рекламный баланс успешно пополнен',
            confirmBusiness: 'Аккаунт успешно подтвержден',
            updated: 'Обновлено',
            success: 'Операция успешно выполнена',
            role: {
                updated: 'Роль успешно обновлена',
                created: 'Новая роль успешно создана',
                removed: 'Роль успешно удалена'
            },
            report: {
                updated: ' Отчет успешно обновлен',
                created: 'Новый отчет успешно создан',
                removed: 'Отчет успешно удален'
            },
            category: {
                updated: ' Категория успешно обновлена',
                created: 'Новая категория успешно создана',
                removed: 'Категория успешно удалена'
            }
        }
    },
    authorManagement: 'Аккаунт находится под авторским управлением до {0}',
    buttons: {
        create: 'Создать',
        cancel: 'Отменить',
        delete: 'Удалить',
        save: 'Сохранить',
        ok: 'ОК',
        change: 'Изменить',
        search: 'Поиск',
        send: 'Отправить',
        checkPhones: 'Проверить телефоны',
        reset: 'Сбросить',
        update: 'Обновить',
        next: 'Дальше',
        resend: 'Не получено смс',
        apply: 'Применить',
        changePhoneNumber: 'Изменить номер телефона',
        download: 'Скачать',
        upload: 'Загрузить',
        withdraw: 'Вывести',
        generate: 'Сформировать',
        excel: 'Скачать таблицу',
        refill: 'Пополнить',
        charge: 'Начислить',
        calculate: 'Рассчитать',
        buy: 'Купить',
        hide: 'Скрыть',
        enabled: 'Активировать',
        disabled: 'Дизактивировать',
        complete: 'Завершить',
        use: 'Использовать',
        check: 'Проверить',
        resetFee: 'Сбросить процент',
        excludeResetFee: 'Учитывать при обнулении'
    },
    notifications: {
        delete: 'Вы уверены, что хотите удалить запись?',
        deletePayout: 'Вы уверены, что хотите отменить заявку на выплату?'
    },
    table: {
        load: 'Данные загружаются...',
        noData: 'Данные отсутствуют'
    },
    date: {
        fromDate: 'Начальная дата',
        toDate: 'Конечная дата',
        date: 'Дата',
        birthday: 'День рождения'
    },
    select: {
        searchBy: 'Искать по',
        selectLeader: 'Выберите лидера',
        selectBusiness: 'Выберите бизнесмена',
        selectCode: 'Выберите код',
        noData: 'Данные отсутствуют',
        selectType: 'Тип'
    },
    phone: {
        countrySelectorLabel: 'Код страны',
        phoneNumberLabel: 'Номер телефона',
        example: 'Например:'
    },
    links: {
        backToPayments: 'Назад к платежам'
    },
    markdown: {
        link: 'ссылка',
        text: 'текст',
        preview: 'Просмотреть'
    },
    noData: {
        empty: 'Список пустой'
    },
    currencies: {
        hrn: 'грн'
    },
    true: 'Да',
    false: 'Нет',
    noDataText: 'Данные отсутствуют',
    others: '{0} других',
    dataIterator: {
        noResultsText: 'Нет результата'
    },
    editDialog: {
        saveText: 'Нажмите Enter чтобы сохранить'
    },
    validateData: {
        cancelled: 'Данные не прошли проверку. Заполните личные данные снова и обновите профиль.',
        check: 'Данные проверяются.',
        filling: 'Заполните все персональные данные, чтобы продолжить работать в системе. В случае указания некорректных данных, Ваш аккаунт может быть заблокирован.'
    }
}
